import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Menu } from '@fiverr-private/orca';
import { KICKSTART_STATUS, SELLER_PLUS_STATUS } from '../../../../constants';
import If from '../../../../lib/If';
import { user, rollouts } from '../../../../PropTypes';
import {
    SellerAnalyticsOverviewLink,
    SellerAnalyticsLoyaltyLink,
    SellerAnalyticsGigConversionLink,
    SellerAnalyticsOrdersBreakdownLink,
    SellerAnalyticsTopKeywordsLink,
    SellerAnalyticsKeywordResearchLink,
} from '../../../SellerLinks';
import SellerDropdown from '../../SellerDropdown';
import GroupHeader from '../GroupHeader';

const Analytics = (props, { user }) => {
    const isSellerPlusEligible = user.sellerPlus?.status === SELLER_PLUS_STATUS.ELIGIBLE;
    const isSellerPlusEnrolled = user.sellerPlus?.status === SELLER_PLUS_STATUS.ENROLLED;
    const isEligibleToKickstartProgram = user.kickstart?.status === KICKSTART_STATUS.ELIGIBLE;
    const isEnrolledToKickstartProgram = user.kickstart?.status === KICKSTART_STATUS.ENROLLED;

    return (
        <SellerDropdown
            triggerLabel={<I18n k="header.submenu.analytics" />}
            menu={
                <Menu className="seller-menu">
                    <Menu.Item>
                        <SellerAnalyticsOverviewLink sellerId={user.id} sellerUsername={user.username} />
                    </Menu.Item>
                    <Menu.Item>
                        <SellerAnalyticsLoyaltyLink sellerId={user.id} sellerUsername={user.username} />
                    </Menu.Item>
                    {/* Seller plus program section */}
                    <If condition={(isSellerPlusEligible && !isEnrolledToKickstartProgram) || isSellerPlusEnrolled}>
                        <Menu.Divider />
                        <GroupHeader labelKey="header.seller_plus" />
                        <Menu.Item>
                            <SellerAnalyticsGigConversionLink sellerId={user.id} sellerUsername={user.username} />
                        </Menu.Item>
                        <Menu.Item>
                            <SellerAnalyticsOrdersBreakdownLink sellerId={user.id} sellerUsername={user.username} />
                        </Menu.Item>
                        <Menu.Item>
                            <SellerAnalyticsTopKeywordsLink sellerId={user.id} sellerUsername={user.username} />
                        </Menu.Item>
                        <Menu.Item>
                            <SellerAnalyticsKeywordResearchLink sellerId={user.id} sellerUsername={user.username} />
                        </Menu.Item>
                    </If>
                    {/* Kickstart program section */}
                    <If
                        condition={
                            (isEligibleToKickstartProgram && !isSellerPlusEligible) || isEnrolledToKickstartProgram
                        }
                    >
                        <Menu.Divider />
                        <GroupHeader labelKey="header.kickstart" />
                        <Menu.Item>
                            <SellerAnalyticsKeywordResearchLink
                                sellerId={user.id}
                                sellerUsername={user.username}
                                isKickstart
                            />
                        </Menu.Item>
                    </If>
                </Menu>
            }
        />
    );
};

Analytics.contextTypes = {
    user,
    rollouts,
};

export default Analytics;
